module.exports = __webpack_public_path__ + "static/media/error_image.8cb77381.svg";